// this is the new js

import 'sg'



// WEBPACK FOOTER //
// app/javascript/packs/sg.js